import * as api from '../../api/api-area-busqueda-casos-informes';
import { 
    GET_CONFIG_FORM92,
    GET_CONSULTA_CASOS,
    CLEAN_CASOS,
    SET_QUERY_STATE
} from '../types';

export const configuracionFormAction92 = (query) => ({
    type: GET_CONFIG_FORM92,
    payload: api.getConfiguracionForm92(query)
});
export const obtenerConsultaCasos = (query) => ({
    type: GET_CONSULTA_CASOS,
    payload: api.getConsultaCasos(query)
});
export const limpiarCasos = () => ({
    type: CLEAN_CASOS,
});
export const setQueryState = (data) => ({
    type: SET_QUERY_STATE,
    payload:data
  
});


